import { render } from "./getBookingList.vue?vue&type=template&id=c85ec632&scoped=true"
import script from "./getBookingList.vue?vue&type=script&lang=js"
export * from "./getBookingList.vue?vue&type=script&lang=js"

import "./getBookingList.vue?vue&type=style&index=0&id=c85ec632&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c85ec632"

export default script